var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from "shared/api/axios-instance";
var STATUS_MAP = {
    LISTED: "listed",
    SOLD: "sold",
    DELISTED: "delisted",
};
var attributesToTraits = function (attributes) {
    return Object.entries(attributes !== null && attributes !== void 0 ? attributes : {}).map(function (_a) {
        var trait_type = _a[0], value = _a[1];
        return ({
            trait_type: trait_type,
            value: String(value),
        });
    });
};
var traitsToAttributes = function (traits) {
    var out = {};
    for (var _i = 0, _a = traits !== null && traits !== void 0 ? traits : []; _i < _a.length; _i++) {
        var t = _a[_i];
        out[t.trait_type] = t.value;
    }
    return out;
};
var toAdminNft = function (it) {
    var _a, _b, _c;
    return ({
        id: it.id,
        collectionId: it.collectionId,
        tokenId: it.tokenIndex != null ? String(it.tokenIndex) : "",
        title: it.name,
        imageUrl: (_a = it.imageUrl) !== null && _a !== void 0 ? _a : "",
        imageAlt: it.name,
        status: (_b = STATUS_MAP[it.status]) !== null && _b !== void 0 ? _b : "new",
        owner: (_c = it.ownerId) !== null && _c !== void 0 ? _c : "",
        traits: attributesToTraits(it.attributes),
        featureFlags: [],
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
    });
};
var str = function (fd, key) { var _a; return (_a = fd.get(key)) !== null && _a !== void 0 ? _a : ""; };
var parseTraits = function (raw) {
    if (!raw)
        return [];
    try {
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    }
    catch (_a) {
        return [];
    }
};
var tokenIndexFrom = function (value) {
    if (!value)
        return undefined;
    var n = Number(value);
    return Number.isInteger(n) && n >= 0 ? n : undefined;
};
var uploadImageIfPresent = function (itemId, fd) { return __awaiter(void 0, void 0, void 0, function () {
    var image, body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                image = fd.get("image");
                if (!(image instanceof File && image.size > 0)) return [3 /*break*/, 2];
                body = new FormData();
                body.append("image", image);
                return [4 /*yield*/, api.put("/admin/items/".concat(itemId, "/image"), body)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
export var nftsAdminApi = {
    getByCollection: function (collectionId) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/collections/".concat(collectionId, "/items"), { params: { limit: 100 } })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data.data.map(toAdminNft)];
            }
        });
    }); },
    listPaged: function (collectionId, params) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/collections/".concat(collectionId, "/items"), {
                        params: {
                            page: params.page,
                            limit: params.limit,
                            status: params.status ? params.status.toUpperCase() : undefined,
                            search: params.search || undefined,
                        },
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, { data: data.data.map(toAdminNft), meta: data.meta }];
            }
        });
    }); },
    getById: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get("/admin/items/".concat(id))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, toAdminNft(data)];
            }
        });
    }); },
    create: function (collectionId, payload) { return __awaiter(void 0, void 0, Promise, function () {
        var item, data, newId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    item = {
                        name: str(payload, "title"),
                        attributes: traitsToAttributes(parseTraits(str(payload, "traits"))),
                        tokenIndex: tokenIndexFrom(str(payload, "tokenId")),
                    };
                    return [4 /*yield*/, api.post("/admin/collections/".concat(collectionId, "/items"), { items: [item] })];
                case 1:
                    data = (_a.sent()).data;
                    newId = data.ids[0];
                    return [4 /*yield*/, uploadImageIfPresent(newId, payload)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, nftsAdminApi.getById(newId)];
            }
        });
    }); },
    // Создаёт все NFT-слоты ОДНИМ батч-запросом (корректный последовательный
    // tokenIndex), затем параллельно грузит картинки по полученным id. Заметно
    // быстрее, чем последовательное создание по одному (устраняет «зависание»).
    createSlots: function (collectionId, items) { return __awaiter(void 0, void 0, Promise, function () {
        var data, ids;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!items.length)
                        return [2 /*return*/];
                    return [4 /*yield*/, api.post("/admin/collections/".concat(collectionId, "/items"), { items: items.map(function (it) { return ({ name: it.name }); }) })];
                case 1:
                    data = (_b.sent()).data;
                    ids = (_a = data.ids) !== null && _a !== void 0 ? _a : [];
                    return [4 /*yield*/, Promise.all(items.map(function (it, i) {
                            if (!it.image || !ids[i])
                                return Promise.resolve();
                            var body = new FormData();
                            body.append("image", it.image);
                            return api.put("/admin/items/".concat(ids[i], "/image"), body).catch(function () { return undefined; });
                        }))];
                case 2:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    createBatch: function (collectionId, items) { return __awaiter(void 0, void 0, Promise, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/admin/collections/".concat(collectionId, "/items"), {
                        items: items.map(function (it) { return ({
                            name: it.title,
                            imageUrl: it.imageUrl || undefined,
                            attributes: traitsToAttributes(it.traits),
                            tokenIndex: typeof it.tokenId === "string"
                                ? tokenIndexFrom(it.tokenId)
                                : it.tokenId,
                        }); }),
                    })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, { created: data.created }];
            }
        });
    }); },
    update: function (id, payload) { return __awaiter(void 0, void 0, Promise, function () {
        var body, tokenIndex;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        name: str(payload, "title"),
                        attributes: traitsToAttributes(parseTraits(str(payload, "traits"))),
                    };
                    tokenIndex = tokenIndexFrom(str(payload, "tokenId"));
                    if (tokenIndex !== undefined)
                        body.tokenIndex = tokenIndex;
                    return [4 /*yield*/, api.patch("/admin/items/".concat(id), body)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, uploadImageIfPresent(id, payload)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, nftsAdminApi.getById(id)];
            }
        });
    }); },
    deleteOne: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.delete("/admin/items/".concat(id))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); },
    // Force-delist — POST /admin/items/:id/delist (status → DELISTED, price reset)
    delist: function (id) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.post("/admin/items/".concat(id, "/delist"))];
                case 1:
                    _a.sent();
                    return [2 /*return*/, nftsAdminApi.getById(id)];
            }
        });
    }); },
    // ── No backend storage — graceful no-ops (re-read current entity) ──
    resyncOwner: function (id) { return __awaiter(void 0, void 0, Promise, function () { return __generator(this, function (_a) {
        return [2 /*return*/, nftsAdminApi.getById(id)];
    }); }); },
    toggleFeatureFlag: function (id, _flag) { return __awaiter(void 0, void 0, Promise, function () { return __generator(this, function (_a) {
        return [2 /*return*/, nftsAdminApi.getById(id)];
    }); }); },
};
